import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {MotionPathPlugin} from "gsap/MotionPathPlugin";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

function scrollAnimations() {

	/* General scroll up animation - when the element comes into view, it will appear */
	const boxes = gsap.utils.toArray('.gsap-scroll-up');

	boxes.forEach((box, i) => {
		const anim = gsap.fromTo(box, {y: 150}, {duration: 1, y: 0});
		ScrollTrigger.create({
			trigger: box,
			animation: anim,
			scrub: 1,
			start: "top bottom",
			end: "bottom 100px",
			toggleActions: 'restart none none pause',
		});
	});



	const mm = gsap.matchMedia();
	const players = gsap.utils.toArray('.oohmplayer');

	mm.add("(min-width: 1024px) and (max-width: 1226px)", () => {
		initAnimation({ xPercent: -200 });
	});
	mm.add("(min-width: 1227px) and (max-width: 1439)", () => {
		initAnimation({ xPercent: -250 });
	});
	mm.add("(min-width: 1440px) and (max-width: 1559px)", () => {
		initAnimation({ xPercent: -300 });
	});
	mm.add("(min-width: 1560px) and (max-width: 2047px)", () => {
		initAnimation({ xPercent: -350 });
	});
	mm.add("(min-width: 2048px)", () => {
		initAnimation({ xPercent: -450 });
	});

	function initAnimation(config) {
		// console.log('doing the animation', config);
		players.forEach((player) => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: player,
					start: "top center",
					end: "1100px top",
					scrub: 0.5,
					anticipatePin: 1,
					pin: true,
					markers: false,
				}
			});

			tl.to(player, {
				motionPath: {
					path: [{ xPercent: config.xPercent, yPercent: 0 }], // Dynamischer Wert
					curviness: 0,
					autoRotate: false
				},
				duration: 1,
				ease: "power4.out"
			})
			.to(player, {}, 0.6)
			.to(player, {
				scale: 1.3,
				duration: 0.4,
				ease: "power3.inOut"
			}, "-=0.5")
			.to(player, {
				motionPath: {
					path: [{ xPercent: 0, yPercent: 0 }],
					curviness: 0,
					autoRotate: false
				},
				scale: 1,
				duration: 1,
				ease: "power2.inOut"
			});
		});
	}




	const cards = gsap.utils.toArray('.ctatexticon');

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.cta-wrapper',
			start: "top bottom",
			end: "+=100%",
			scrub: 1, // Smooth scrolling animation
			// toggleActions: "play none none reverse", // doesnt do anything iwth scrub
		}
	})
	tl.from('.ctatexticon', {
		opacity: 0,
		yPercent: 100,
		duration: 1,
		stagger: 0.5, // Adjust the stagger time as needed
		ease: "Power1.easeOut", // You can change the easing function,
	})

	const areaslides = gsap.utils.toArray('.area-slider .swiper-slide');

	const areaslidetl = gsap.timeline({
		scrollTrigger: {
			trigger: '.area-slider',
			start: "top bottom",
			end: "+=50%",
			scrub: 1, // Smooth scrolling animation
			// toggleActions: "play none none reverse", // doesnt do anything iwth scrub
		}
	})
	areaslidetl.from(areaslides, {
		opacity: 0,
		xPercent: 100,
		duration: 1,
		stagger: 0.5, // Adjust the stagger time as needed
		ease: "Power1.easeOut", // You can change the easing function,
	})

}

export {scrollAnimations};
